import { MustacheTemplateVariablesDto } from '@act/shared/data-transfer-objects';
import Mustache from 'mustache';

export interface TemplateValidationResult {
  renderedTemplate: string;
  missingVariables: string[];
  hasMissingVariables: boolean;
}

export function applyMustacheTemplate(
  template: string,
  templateVariables: MustacheTemplateVariablesDto
): string {
  return Mustache.render(template, templateVariables);
}

export function applyMustacheTemplateWithValidation(
  template: string,
  templateVariables: MustacheTemplateVariablesDto
): TemplateValidationResult {
  // Extract all variables from the template using regex (handles both {{}} and {{{}}})
  const variableRegex = /\{\{\{?([^}]+)\}?\}\}/g;
  const templateVariablesInUse = new Set<string>();
  let match;

  while ((match = variableRegex.exec(template)) !== null) {
    templateVariablesInUse.add(match[1].trim());
  }

  // Check which variables are missing or empty
  const missingVariables: string[] = [];
  templateVariablesInUse.forEach(variable => {
    const value = templateVariables[variable];
    if (value === undefined || value === null || value === '') {
      missingVariables.push(variable);
    }
  });

  // Render the template
  const renderedTemplate = Mustache.render(template, templateVariables);

  return {
    renderedTemplate,
    missingVariables,
    hasMissingVariables: missingVariables.length > 0,
  };
}
